import Skeleton from "react-loading-skeleton";
import { PayoutHealthSkeleton } from "./components/PayoutHealthCard";

/**
 * Skeleton for the onboarding checklist card
 */
export function OnboardingChecklistSkeleton() {
	return (
		<div className="rounded-xl border border-base-content/10 bg-base-100 p-6">
			<div className="mb-4 flex items-center justify-between">
				<div>
					<Skeleton width={140} height={22} />
					<Skeleton width={180} height={14} className="mt-1" />
				</div>
				<Skeleton width={28} height={28} borderRadius={6} />
			</div>
			<Skeleton height={6} borderRadius={999} className="mb-5" />
			<div className="space-y-1">
				{[1, 2, 3, 4, 5, 6].map((i) => (
					<div key={i} className="flex items-center gap-3 px-2 py-2">
						<Skeleton width={20} height={20} circle />
						<Skeleton width={180 + i * 10} height={16} />
					</div>
				))}
			</div>
		</div>
	);
}

/**
 * Skeleton for the stats cards grid
 */
export function StatsSkeleton() {
	return (
		<div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-5">
			{[1, 2, 3, 4, 5].map((i) => (
				<div
					key={i}
					className="rounded-xl border border-base-content/10 bg-base-100 p-6"
				>
					<Skeleton width={80} height={16} />
					<Skeleton width={120} height={36} className="mt-2" />
					<Skeleton width={100} height={12} className="mt-1" />
				</div>
			))}
		</div>
	);
}

/**
 * Skeleton for the charts section
 */
export function ChartsSkeleton() {
	return (
		<>
			{/* Charts Row 1: Revenue + Pie Chart */}
			<div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
				<div className="lg:col-span-2">
					<Skeleton width={160} height={20} className="mb-2" />
					<Skeleton height={300} borderRadius={12} />
				</div>
				<div>
					<Skeleton width={140} height={20} className="mb-2" />
					<Skeleton height={300} borderRadius={12} />
				</div>
			</div>

			{/* Charts Row 2: Attributions */}
			<div>
				<Skeleton width={180} height={20} className="mb-2" />
				<Skeleton height={300} borderRadius={12} />
			</div>

			{/* Charts Row 3: Partner Leaderboard */}
			<div>
				<Skeleton width={120} height={20} className="mb-2" />
				<Skeleton height={240} borderRadius={12} />
			</div>
		</>
	);
}

/**
 * Full-page skeleton for the Dashboard route's pendingComponent.
 * Shows loading state for stats, payout health, and charts.
 */
export function DashboardPageSkeleton() {
	return (
		<div className="space-y-6">
			{/* Header */}
			<div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
				<Skeleton width={320} height={20} />
				<div className="flex items-center gap-4">
					<Skeleton width={24} height={24} circle />
					<Skeleton width={192} height={38} borderRadius={8} />
				</div>
			</div>

			<StatsSkeleton />
			<PayoutHealthSkeleton />
			<ChartsSkeleton />
		</div>
	);
}
